import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITableCellViewModel, ITableColumnViewModel, ITableDataViewModel, ITableRowViewModel, ITableTitleDataModel, ITableTotalRowViewModel, ITableTotalViewModel, ITableViewModel } from '../../entities/view-model';
import { isNumeric } from 'rxjs/internal-compatibility';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit {

  constructor() { }

  @Input() vm: ITableViewModel;
  @Input() data: any;
  @Input() tableMaxHeight: number = undefined;
  @Input() searchableColumns: number[] = undefined;
  @Input() searchableTotalColumns: number[] = undefined;
  @Input() showTotalsOnTop: boolean = false;
  @Input() keyIndex: number = 0;
  @Input() baseCode: string = undefined;
  @Input() baseAction: string = undefined;
  @Input() activeLineIndex: number = 0;
  @Output() showDetails = new EventEmitter<any>();
  
  private searchData: string = '';
  showSearchInput: boolean = true;
  showLink: boolean = false;
  workingText: string = '';


  ngOnInit(): void {
    this.showLink = this.baseCode?.length > 0 ? true : false;

    var totalRowCount: number = 0;
    this.vm?.totals?.forEach(t => {
      t.rows.map(r => {
        if (r.cellRows.length > totalRowCount)
          totalRowCount = r.cellRows.length;
      });
    });
    this.showSearchInput = totalRowCount > 1 ? false : true;
  }

  setColumnStyle(c: ITableColumnViewModel): string {
    return c.style?.styles?.join(' ');
  }

  setCellStyle(r: ITableCellViewModel): string {
    return r.style?.styles?.join(' ');
  }

  setToolTip(r: ITableCellViewModel, idx: number): string {
    return (r.tooltip ?? '').length > 0 ? r.tooltip : '';
  }

  setTitleToolTip(r: ITableTitleDataModel, idx: number): string {
    return (r.tooltip ?? '').length > 0 ? r.tooltip : '';
  }

  setCellRowToolTip(r: ITableDataViewModel): string {
    return (r.tooltip ?? '').length > 0 ? r.tooltip : '';
  }

  setCellRowStyle(cr: ITableDataViewModel, coll: string, lineIdx: number): string {
    var highlightClass: string = '';
    if (lineIdx != -1 && this.activeLineIndex >= 0) {
      if (this.activeLineIndex == lineIdx) {
        highlightClass = ' font-weight-bold';
      } else {
        highlightClass = ' grayout';
      }
    }
    return cr.style?.styles?.join(' ') + ((coll ?? '').length > 0 ? ` ${coll}` : '') + highlightClass;
  }

  setCellRowTitleStyle(cr: ITableDataViewModel, coll: string, lineIdx: number): string {
    var highlightClass: string = '';
    if (lineIdx != -1 && this.activeLineIndex >= 0) {
      if (this.activeLineIndex == lineIdx) {
        highlightClass = ' font-weight-bold';
      } else {
        highlightClass = ' grayout';
      }
    }
    return cr.title?.style?.styles?.join(' ') + ((coll ?? '').length > 0 ? ` ${coll}` : '') + highlightClass;
  }

  setTotalsStyle(t: ITableTotalRowViewModel): string {
    return t.style?.styles?.join(' ');
  }

  doDataSearch(vm: ITableViewModel, searchVal: string) {

    this.vm.searchValue = searchVal;
    if (searchVal.length === 0) {
      vm.rowsFiltered = this.vm.rows;

      this.filterTotals(vm);
      return;
    }
    
    vm.rowsFiltered = [];
    vm.rows.forEach(r => {
      r.cells.forEach((c, i) => {
        if (!this.searchableColumns || this.searchableColumns.find(sc => sc == i) == i) {
          c.cellRows.forEach(cr => {
            if (searchVal.substring(0, 1) == '=') {
              if (cr.data.toLowerCase() == searchVal.substring(1).toLowerCase()) {
                vm.rowsFiltered.push(r);
              }
            } else {
              if (cr.data.toLowerCase().indexOf(searchVal.toLowerCase()) > -1) {
                vm.rowsFiltered.push(r);
              }
            }
          })
        }
      })
    });

    this.filterTotals(vm);
  }

  filterTotals(vm: ITableViewModel) {
    const totals = function (arr: any[]): any {
      var total: number = 0;
      arr.forEach(a => {
        total += !isNaN(Number(a)) ? Number(a) : 0
      });
      return total;
    };

    if (vm.totalsFiltered.length == 1) {
      var t = vm.totalsFiltered[0];
      t.rows.forEach((r, i) => {
        r.cellRows.forEach(c => {
          var origData = c.data;
          if (String(c.data).length > 0 && !isNaN(Number(c.data.replaceAll(',', '').replaceAll('$', '').replaceAll('(', '').replaceAll(')', '')))) {
            c.data = totals(
              vm.rowsFiltered.map(rf => 
                (rf.cells[i].cellRows[0].data.replaceAll(',', '').replaceAll('$', '').replaceAll('(', '').replaceAll(')', ''))
                  * (String(rf.cells[i].cellRows[0].data).indexOf('(') !== -1 ? -1 : 1)
              ))
            c.data = String(origData).indexOf('$') !== -1 
              ? String(c.data).indexOf('-') !== -1
                ? `(${c.data.toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits: 0, maximumFractionDigits: 0 }).replaceAll('-', '')})`
                : c.data.toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits: 0, maximumFractionDigits: 0 }).replaceAll('-', '')
              : c.data.toLocaleString()
          }
        })
      });
    }
  }

  /**
   * 
   */
  showDetailsPanel(code: any) {
      this.showDetails.emit({code: code, data: this.data, baseCode: this.baseCode, baseAction: this.baseAction});
  }

  sortColumnClicked(columns: ITableColumnViewModel[], idx: number, r: ITableRowViewModel[]) {

    this.sortColumnImpl(columns, idx, r);
  }

  async sortColumnImpl(columns: ITableColumnViewModel[], idx: number, r: ITableRowViewModel[]) {

    let sortOrder : number = 1;
    columns.forEach((c, i) => {
      if (i == idx) {
        sortOrder = c.sortDirection == 'down' ? -1 : 1;
        c.sortDirection = c.sortDirection == 'down' ? 'up' : 'down';
      }
      else c.sortDirection = '';
    });
    
    const result = await Promise.all(r.sort((a, b) => {
      if (!this.searchableColumns || this.searchableColumns.find(sc => sc == idx) == idx) {
        const nameA = a.cells[idx].cellRows[0].data.toUpperCase(); // ignore upper and lowercase
        const nameB = b.cells[idx].cellRows[0].data.toUpperCase(); // ignore upper and lowercase

        var result = (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0;
        return result * sortOrder;
      }

      const valueA = a.cells[idx].cellRows[this.activeLineIndex].data.replaceAll(',', '').replaceAll('$', '').replaceAll('(', '').replaceAll(')', ''); 
      const valueB = b.cells[idx].cellRows[this.activeLineIndex].data.replaceAll(',', '').replaceAll('$', '').replaceAll('(', '').replaceAll(')', ''); 

      const numberA = !isNaN(Number(valueA)) ? Number(valueA) : valueA;
      const numberB = !isNaN(Number(valueB)) ? Number(valueB) : valueB;

      var result = (numberA < numberB) ? -1 : (numberA > numberB) ? 1 : 0;
      return result * sortOrder;
    }));
    return result;
  }
}
